var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.createplusCategoriesStatus)?[_c('create-plus-category-tiles',{attrs:{"createplusCategories":_vm.initialDisplayedCategories}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }